export  const columns = [
        {
            key: "srn",
            label: "SRN",
            render: (_, index) => index + 1,
        },
        { key: "date", label: "Booking Date" },
        { key: "service", label: "Service Name" },
        { key: "amount", label: "Paid Amount (₹)" },
        { key: "bookingId", label: "Booking ID" },
        { key: "type", label: "Service Type" },
    ];

    export const data = [
        {
            date: "10-Jan-2026",
            service: "OPD Consultation",
            amount: 500,
            bookingId: "BK1001",
            type: "Doctor",
        },
        {
            date: "15-Jan-2026",
            service: "Blood Test",
            amount: 1200,
            bookingId: "BK1002",
            type: "Lab",
        },
        {
            date: "20-Jan-2026",
            service: "Medicine Purchase",
            amount: 850,
            bookingId: "BK1003",
            type: "Pharmacy",
        },
        {
            date: "10-Jan-2026",
            service: "OPD Consultation",
            amount: 500,
            bookingId: "BK1001",
            type: "Doctor",
        },
        {
            date: "15-Jan-2026",
            service: "Blood Test",
            amount: 1200,
            bookingId: "BK1002",
            type: "Lab",
        },
        {
            date: "20-Jan-2026",
            service: "Medicine Purchase",
            amount: 850,
            bookingId: "BK1003",
            type: "Pharmacy",
        },
    ];


